import { api } from '../core';

type BundleMarkDuplicatesResponse = null;

export type BundleMarkDuplicatesProps = {
  bundleId: string;
  pageIds: string[];
};

const postBundleMarkDuplicatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postBundleMarkDuplicates: builder.query<BundleMarkDuplicatesResponse, BundleMarkDuplicatesProps>({
      query: ({ bundleId, ...otherData }: BundleMarkDuplicatesProps) => ({
        url: 'bundle/mark-duplicates',
        method: 'POST',
        body: { bundle_id: bundleId, ...otherData }
      }),
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postBundleMarkDuplicates in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostBundleMarkDuplicatesQuery } = postBundleMarkDuplicatesApi;
